module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ms-93d49f30c7b27ece2601602b3960cecf.svg";